import { AutoComplete, Breadcrumb, DatePickerInput, LabelCheckbox, SuccessPopupModal, TextInput, Title } from '../../Components/Atoms';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Button, useToast } from '@chakra-ui/react';
import { getStatesByCountryId, getCitiesByStateID, saveClientDetails, saveDealershipDetails, getAllMakes, createSubUser, updateSubUser, getUserAndVehicleDetails } from '../../APIs';
import PATH from '../../Routes/paths';
import './style.css';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { isValidMobile } from '../../Library/validations';
import { StoreContext } from '../../Library/contexts';

const FIELD_TYPE = {
  LABEL: 1,
  TEXT: 2,
  AUTOCOMPLETE: 3,
  DATEPICKER: 4,
  CHECKBOX: 5,
}

const AddClient = () => {
  const isRevFinRef = useRef(window.localStorage.getItem("des") === "6");

  const addClientInitialState = {
    cName: "",
    eml: "",
    pincode: "",
    city: "",
    state: "",
    add: "",
    gstNum: "",
    amtPrVeh: "",
    dmNm: "",
    dmMob: "",
    dmEml: ""
  }
  const addDealershipInitialState = {
    nm: "",
    mob: "",
    amob:"",
    eml: "",
    gstno: "",
    sNm: "",
    cNm: "",
    st:null,
    ct:null,
    vmk:"",
    mk:"",
    pin: "",
    add: "",
    dnm: "",
    dmob: "",
    deml: "",
    ddes: ""
  }
  const { allSubUsers, setAllSubUsers } = useContext(StoreContext);
  const subUserInitialState = { nm: "", mob: "", altMob: "", eml: "", pwd: "", isa: true };
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isEdit = searchParams.get('edit') === "true";
  const fromSubUsers = searchParams.get("fromSubUsers") === "1";
  const subUser = location.pathname.includes(PATH.SUB_USERS);
  const [subUserDetails, setSubUserDetails] = useState({});
  const [formData, setFormData] = useState(subUser ? subUserInitialState : isRevFinRef.current ? addDealershipInitialState : addClientInitialState);
  const [formErrors, setFormErrors] = useState({});
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [oemOptions, setOemOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [navigatePath, setNavigatePath] = useState("");
  const Navigate = useNavigate();
  const formRef = useRef("");
  const Toast = useToast();

  useEffect(() => {
    if (!allSubUsers || !allSubUsers.length) {
      getUserAndVehicleDetails({}, (err, data=[]) => {
        if (err) console.error("Error fetching sub users");
        else {
          const updatedData = data.map((user) => ({
            ...user,
            nm: `${user.fn || ""} ${user.mn || ""} ${user.ln || ""}`.trim(),
          }));
          setAllSubUsers(updatedData);
        }
      });
    } else {
      let mob = +searchParams.get("mob");
      let userToEdit = allSubUsers.find(user => user.mob === mob);
      if (userToEdit && userToEdit.idx) {
        setSubUserDetails(userToEdit);
        setFormData({ ...formData, nm: userToEdit.nm, eml: userToEdit.eml, mob: userToEdit.mob, isa: userToEdit.isa, idx: userToEdit.idx, altMob: userToEdit.altMob || "", });
      }
    }
  }, [ allSubUsers, setAllSubUsers ]);


  useEffect(() => {
    if (subUser) return;
    getStatesByCountryId()
    .then((data) => {
      if (data.length){
        let options = [];
        data.sort((a, b) => a.nm.localeCompare(b.nm));
        data.forEach(state => {
          if (state.nm && state.idx)
            options.push({ label: state.nm, value: state.idx });
        });
        setStateOptions(options);
      }
    })
    .catch((err)=> console.error("AddClient fetch states failed.", err))

    getAllMakes((err,data)=>{
      if(err){
        console.error("AddDealership fetch oems failed.", err);
      }
      else if (data.length){
        let options = [];
        data.sort((a, b) => a.nm.localeCompare(b.nm));
        data.forEach(oem => {
          if (oem.nm && oem.idx)
            options.push({ label: oem.nm, value: oem.idx });
        });
        setOemOptions(options);
      }
    })
  }, []);

  const addClientFormFields = useMemo(() => [
    {
      type: FIELD_TYPE.TEXT,
      label: "Company Name",
      name: "cName",
      placeholder: "Enter Company Name",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Email Address",
      name: "eml",
      placeholder: "Enter Email Address",
      regex: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      required: true
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "State",
      name: "state",
      placeholder: "Select State",
      cls: "add-client-halfw",
      options: stateOptions,
      onChange: (stateId) => {
        if (formData.state === stateId)
          return;

         setFormFieldData('state')(stateId);
         setFormFieldData('city')("");
        getCitiesByStateID(stateId).then((data) => {
          if (data.length) {
            let options = [];
            data.sort((a, b) => a.nm.toLowerCase() > b.nm.toLowerCase());
            data.forEach(state => {
              if (state.nm && state.idx)
                options.push({ label: state.nm, value: state.idx });
            });
            setCityOptions(options);
          }
        })
          .catch((err) => console.error("AddClient fetch states failed.", err))
      },
      required: true
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "City",
      name: "city",
      placeholder: "Select City",
      cls: "add-client-halfw",
      options: cityOptions,
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Address",
      name: "add",
      cls: "add-client-halfw",
      placeholder: "Enter Address",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Pincode",
      name: "pincode",
      placeholder: "Enter Pincode",
      regex: /^[1-9][0-9]{5}$/,
      cls: "add-client-halfw",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "GST Number",
      name: "gstNum",
      placeholder: "Enter GST Number",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Amount per vehicle",
      name: "amtPrVeh",
      placeholder: "Enter Amount per vehicle",
      rightText: "Per day",
      regex: /^\d*\.?\d+$/,
      cls: "add-client-halfw",
      required: true
    },
    {
      type: FIELD_TYPE.LABEL,
      label: "Contact Person Details",
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Name",
      name: "dmNm",
      placeholder: "Enter Name",
      cls: "add-client-halfw",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Mobile Number",
      name: "dmMob",
      placeholder: "Enter Mobile Number",
      cls: "add-client-halfw",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Email Address",
      name: "dmEml",
      placeholder: "Enter Email Address",
      regex: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      required: true
    },
  ], [stateOptions, cityOptions, formData.state]);


  const addDealershipFormFields = useMemo(() => [
    {
      type: FIELD_TYPE.TEXT,
      label: "Dealership Name",
      name: "nm",
      placeholder: "Enter Dealership Name",
      required: true,
      cls: "add-client-halfw",
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "OEM",
      name: "mk",
      placeholder: "Select OEM",
      required: true,
      cls: "add-client-halfw",
      options: oemOptions,
      onChange: (oemId, oemObj) => {
        setFormFieldData('vmk')(oemObj.label);
        setFormFieldData('mk')(oemObj.value);
      }
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Mobile Number",
      name: "mob",
      cls: "add-client-halfw",
      placeholder: "Enter Mobile Number",
      required: true,
      regex: /^[6-9]\d{9}$/,
    },
    {
      type: FIELD_TYPE.TEXT,
      label:"Alternate  Number",
      name: "amob",
      cls: "add-client-halfw",
      placeholder: "Enter Alternate Mobile Number",
      regex: /^[6-9]\d{9}$/,
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Email Address",
      name: "eml",
      placeholder: "Enter Email Address",
      regex: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "GST Number",
      name: "gstno",
      placeholder: "Enter GST Number",
      required: false
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "State",
      name: "st",
      placeholder: "Select State",
      cls: "add-client-halfw",
      options: stateOptions,
      onChange: (stateId, stateObj) => {

        if (formData.st === stateId)
          return;

        setFormFieldData('sNm')(stateObj.label);
        setFormFieldData('st')(stateObj.value);
        setFormFieldData('ct')("");
        setFormFieldData('cNm')("");
        getCitiesByStateID(stateId).then((data) => {
          if (data.length) {
            let options = [];
            data.sort((a, b) => a.nm.toLowerCase() > b.nm.toLowerCase());
            data.forEach(state => {
              if (state.nm && state.idx)
                options.push({ label: state.nm, value: state.idx });
            });
            setCityOptions(options);
          }
        })
          .catch((err) => console.error("AddClient fetch states failed.", err))
      },
      required: true
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "City",
      name: "ct",
      placeholder: "Select City",
      cls: "add-client-halfw",
      options: cityOptions,
      onChange: (_, cityObj) => {
        setFormFieldData('ct')(cityObj.value);
        setFormFieldData('cNm')(cityObj.label);
      },
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Pincode",
      name: "pin",
      placeholder: "Enter Pincode",
      regex: /^[1-9][0-9]{5}$/,
      cls: "add-client-halfw",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Address",
      name: "add",
      placeholder: "Enter Address",
      required: true
    },

    {
      type: FIELD_TYPE.LABEL,
      label: "Contact Person Details",
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Name",
      name: "dnm",
      placeholder: "Enter Name",
      cls: "add-client-halfw",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Mobile Number",
      name: "dmob",
      placeholder: "Enter Mobile Number",
      cls: "add-client-halfw",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Email Address",
      name: "deml",
      placeholder: "Enter Email Address",
      regex: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Designation",
      name: "ddes",
      placeholder: "Enter Designation",
      required: true
    },
  ], [oemOptions, stateOptions, cityOptions, formData.st]);

   let createEditSubUserFormFields = [
      {
        type: FIELD_TYPE.TEXT,
        label: "Subuser Name",
        name: "nm",
        placeholder: "Enter Subuser Name",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Mobile Number",
        name: "mob",
        placeholder: "Enter Subuser Mobile Number",
        required: true,
        cls: "add-client-halfw",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Alternate Number",
        name: "altMob",
        placeholder: "Enter Subuser Alternate Number",
        cls: "add-client-halfw",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Email Address",
        name: "eml",
        placeholder: "Enter Subuser Email Address",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Set Password",
        name: "pwd",
        placeholder: "Enter Password",
        required: isEdit ? false : true,
        cls: "add-client-halfw",
      },
      {
        type: FIELD_TYPE.CHECKBOX,
        label: "Activate Subuser Account",
        name: "isa",
        onChange: (e) => {
          setFormData(prev => ({ ...prev, isa: e.target.checked }));
        },
      },
    ];

    if (isEdit) {
      createEditSubUserFormFields.splice(5, 0, {
        type: FIELD_TYPE.TEXT,
        label: "Confirm Password",
        name: "confirmPwd",
        placeholder: "Confirm Password",
        required: false,
        cls: "add-client-halfw",
      })
    }

  const setFormFieldData = (key) => (value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const saveClientData = (modelData) => {
    let postFunction = saveClientDetails;
    if (isRevFinRef.current) postFunction = saveDealershipDetails;
    if (subUser) {
      postFunction = createSubUser;
      if (isEdit) postFunction = updateSubUser;
    }

    postFunction(modelData, (failure, success) => {
      if (failure) {
        let errMsg = "";
        try {
          errMsg = JSON.parse(failure).data;
        } catch (e) {
          errMsg = failure;
        }
        Toast({ isClosable: true, description: errMsg, position: "bottom", variant: "subtle", duration: 3000 })
      }
      else {
        setFormData(subUser ? subUserInitialState : isRevFinRef.current ? addDealershipInitialState : addClientInitialState);
        if (subUser) {
          let updatedData = allSubUsers.map((sub) =>
            sub.idx === modelData.idx ? { ...sub, ...modelData } : sub
          );
          let url = PATH.SUB_USERS;
          if (!isEdit) url += `?fetchSubUsers=1`;

          setNavigatePath(url);
          setAllSubUsers(updatedData);
          setModalMsg(`Subuser ${isEdit ? "details updated" : "added"} successfully`);
        } else if (isRevFinRef.current) {
          setModalMsg("Dealership added successfully");
          setNavigatePath(PATH.SHOW_DEALERS);
        } else {
          setModalMsg("Client added successfully");
          setNavigatePath(PATH.CLIENTS);
        }
        setIsOpen(true);
      };
    })
  };

  const checkSubUserChanges = (formdata) => {
    let allowSave = false;

    if (formdata.nm !== subUserDetails.nm) allowSave = true;
    if (formdata.mob !== subUserDetails.mob) allowSave = true;
    if (subUserDetails.altMob && formdata.altMob !== subUserDetails.altMob) allowSave = true;
    if (subUserDetails.eml && formdata.eml !== subUserDetails.eml) allowSave = true;
    if (formdata.isa !== subUserDetails.isa) allowSave = true;
    if (formdata.pwd && formdata.confirmPwd && formdata.pwd === formdata.confirmPwd) allowSave = true;

    if (allowSave) saveClientData(formdata);
    else Toast({ isClosable: true, description: "Nothing to save", position: "bottom", variant: "subtle", duration: 3000 });
  }

  const submitHandler = () => {
    let errors = {};
    let feildsArray = subUser ? createEditSubUserFormFields : isRevFinRef.current ? addDealershipFormFields : addClientFormFields;

    for (let idx in feildsArray) {
      let field = feildsArray[idx];
      let isInvalid = false;

      if (field.name && field.required) {
        if (!formData[field.name]) {
          errors[field.name] = field.type === FIELD_TYPE.TEXT ? `Please enter ${field.label.toLowerCase()}` : `Please select ${field.label.toLowerCase()}`;
          isInvalid = true;
        } else if (field.regex && !field.regex.test(formData[field.name])) {
          errors[field.name] = `Please enter valid ${field.label.toLowerCase()}`;
          isInvalid = true;
        }
      } else {
        if (field.name === "amob") {
          if (formData[field.name]) {
            if (!isValidMobile(formData[field.name])){
              errors[field.name] = field.type === FIELD_TYPE.TEXT ? `Please enter ${field.label.toLowerCase()}` : `Please select ${field.label.toLowerCase()}`;
              isInvalid = true;
            }
          } else delete formData.amob;
        }
        if(field.name === "gstno" && !formData[field.name]){
          delete formData.gstno;
        }
        if (isEdit && (field.name === "pwd" || field.name === "confirmPwd")) {
          if (formData["pwd"] && !formData["confirmPwd"]) {
            errors["confirmPwd"] = "Please enter confirm password!!"
            isInvalid = true;
          }
          else if (!formData["pwd"] && formData["confirmPwd"]) {
            errors["pwd"] = "Please enter set password!!"
            isInvalid = true;
          }
          else if ((formData["pwd"] && formData["confirmPwd"]) && (formData["pwd"] !== formData["confirmPwd"])) {
            errors["pwd"] = errors["confirmPwd"] = "Passwords do not match"
            isInvalid = true;
          }
        }
      }
      if (isInvalid){
        formRef.current[idx].scrollIntoView({ behavior: "smooth", block: "center" });
        break;
      }
    }
    if (Object.keys(errors).length) {
      return setFormErrors(errors);
    } else setFormErrors({});

    if (isEdit && subUser) checkSubUserChanges(formData);
    else saveClientData(formData);
  }

const getTitles = (type) => {
  const titles = {
    button: {
      subUser: isEdit ? "Save" : "Create Subuser",
      dealership: "Add Dealership",
      client: "Add Client",
    },
    page: {
      subUser: isEdit ? "Edit Details" : "Create New Subuser",
      dealership: "Add Dealership",
      client: "Add Client",
    },
  };

  if (subUser) return titles[type].subUser;
  return isRevFinRef.current ? titles[type].dealership : titles[type].client;
};

const getBreadCrumbPaths = () => {
  if (subUser) {
    const paths = [
      { idx: 1, name: "Subusers", link: PATH.SUB_USERS },
    ];
    if (isEdit) {
      if (fromSubUsers) {
        paths.push(
          { idx: 2, name: getTitles("page"), link: "", isCurrentPage: true }
        );
      } else {
        paths.push(
          { idx: 2, name: formData.nm || "Sub user", link: `${PATH.SUB_USERS}/${PATH.SUB_USER_DETS}?mob=${formData.mob}` },
          { idx: 3, name: getTitles("page"), link: "", isCurrentPage: true }
        );
      }
    } else {
      paths.push({ idx: 2, name: getTitles("page"), link: "", isCurrentPage: true });
    }
    return paths;
  }

  return isRevFinRef.current
    ? [
        { idx: 1, name: "Dealerships", link: PATH.SHOW_DEALERS },
        { idx: 2, name: "Add Dealership", link: "", isCurrentPage: true },
      ]
    : [
        { idx: 1, name: "Lease", link: PATH.LEASE },
        { idx: 2, name: "Add Client", link: "", isCurrentPage: true },
      ];
};

  return (
    <section className={`panel-main ${isRevFinRef.current ? "dealership-form" : ""}`}>
      <div >
        <Breadcrumb paths={getBreadCrumbPaths()} />
      </div>

      <div className='add-client'>
        <Title>{getTitles("page")}</Title>
        <form className='add-client-form' ref={formRef}>
          {
            isRevFinRef.current
             ?
             addDealershipFormFields.map((formField, idx) => {
              return <div key={idx} className={formField.cls ? formField.cls : "add-client-fullw"}>
                {
                  formField.type === FIELD_TYPE.LABEL && (
                    <p key={idx} className="add-client-subheadings">{formField.label || ""}</p>
                  )
                }
                {
                  formField.type === FIELD_TYPE.TEXT && (
                    <TextInput
                      inputName={formField.name || ""}
                      placeholder={formField.placeholder}
                      className="add-client-text-field"
                      label={formField.label}
                      labelClassName="add-client-text-field-label "
                      errMessage={formErrors[formField.name] || ""}
                      rightElement={formField.rightText}
                      inputCover={formField.cls ? "custom-cover-w" : ""}
                      onChange={formField.onChange || setFormFieldData(formField.name)}
                      value={formData[formField.name]}
                      isRequired={formField.required}
                    />
                  )
                }
                {
                  formField.type === FIELD_TYPE.AUTOCOMPLETE && (
                    <AutoComplete
                      options={formField.options || [{ label: "bhopal", value: "bhopal" }]}
                      label={formField.label}
                      autoCompleteClassName={"add-client-autocomplete"}
                      className={`add-client-autocomplete-field ${isRevFinRef.current ? "dealership-field" : ""}`}
                      labelClassName={"add-client-autocomplete-field-label"}
                      placeholder={formField.placeholder}
                      errMessage={formErrors[formField.name] || ""}
                      inputName={formField.name}
                      onChange={formField.onChange || setFormFieldData(formField.name)}
                      inputCover={formField.cls ? "custom-cover-w" : ""}
                      value={formData[formField.name]}
                      isRequired={formField.required}
                    />
                  )
                }
                {
                  formField.type === FIELD_TYPE.DATEPICKER && (
                    <DatePickerInput
                      inputName={formField.name || ""}
                      className="add-client-datepicker-field"
                      label={formField.label}
                      labelClassName="add-client-datepicker-field-label"
                      DatepickerClassName="add-client-datepicker"
                      errMessage={formErrors[formField.name] || ""}
                      inputCover={formField.cls ? "custom-cover-w" : ""}
                      onChange={formField.onChange || setFormFieldData(formField.name)}
                      value={formData[formField.name]}
                      isRequired={formField.required}
                    />
                  )
                }
              </div>
            })
             :
            [...(subUser ? createEditSubUserFormFields : addClientFormFields)].map((formField, idx) => {
              return <div key={idx} className={formField.cls ? formField.cls : "add-client-fullw"}>
                {
                  formField.type === FIELD_TYPE.LABEL && (
                    <p key={idx} className="add-client-subheadings">{formField.label || ""}</p>
                  )
                }
                {
                  formField.type === FIELD_TYPE.TEXT && (
                    <TextInput
                      inputName={formField.name || ""}
                      placeholder={formField.placeholder}
                      className="add-client-text-field"
                      label={formField.label}
                      labelClassName="add-client-text-field-label "
                      errMessage={formErrors[formField.name] || ""}                      
                      rightElement={formField.rightText}
                      inputCover={formField.cls ? "custom-cover-w" : ""}
                      onChange={formField.onChange || setFormFieldData(formField.name)}
                      value={formData[formField.name]}
                      isRequired={formField.required}
                    />
                  )
                }
                {
                  formField.type === FIELD_TYPE.AUTOCOMPLETE && (
                    <AutoComplete
                      options={formField.options || [{ label: "bhopal", value: "bhopal" }]}
                      label={formField.label}
                      autoCompleteClassName={"add-client-autocomplete"}
                      className={"add-client-autocomplete-field"}
                      labelClassName={"add-client-autocomplete-field-label"}
                      placeholder={formField.placeholder}
                      errMessage={formErrors[formField.name] || ""}                      
                      inputName={formField.name}
                      onChange={formField.onChange || setFormFieldData(formField.name)}
                      inputCover={formField.cls ? "custom-cover-w" : ""}
                      value={formData[formField.name]}
                      isRequired={formField.required}
                    />
                  )
                }
                {
                  formField.type === FIELD_TYPE.DATEPICKER && (
                    <DatePickerInput
                      inputName={formField.name || ""}
                      className="add-client-datepicker-field"
                      label={formField.label}
                      labelClassName="add-client-datepicker-field-label"
                      DatepickerClassName="add-client-datepicker"
                      errMessage={formErrors[formField.name] || ""}                      
                      inputCover={formField.cls ? "custom-cover-w" : ""}
                      onChange={formField.onChange || setFormFieldData(formField.name)}
                      value={formData[formField.name]}
                      isRequired={formField.required}
                    />
                  )
                }
                {
                  formField.type === FIELD_TYPE.CHECKBOX && (
                    <LabelCheckbox
                      label={formField.label}
                      name={formField.name}
                      onChange={formField.onChange}
                      isChecked={formData[formField.name]}
                    />
                  )
                }
              </div>
            })
          }
          <div className="add-battery-submit-button">
            <Button className="add-battery-button" onClick={submitHandler} >
              {getTitles("button")}
            </Button>
          </div>
        </form>
      </div>
      <SuccessPopupModal
        open={isOpen}
        modalMsg={modalMsg}
        closeBtn={"Okay"}
        modalSize={"lg"}
        onModalClose={() => { Navigate(navigatePath) }}
      />
    </section>
  )
}

export default AddClient;